export const SessionSkeleton = (
		<li>
			<div className='skeleton'/>
			<p className='skeleton'/>
			<p className='skeleton'/>
			<p className='skeleton'/>
		</li>
)
